export enum AssetType {
  image = 'image',
  html = 'html',
  ggb = 'ggb',
}
